import { UniButton } from '@/design-system/components/buttons';
import { Icon } from '@/design-system/components/icons/Icon';
import { TextBody, TextTitle } from '@/design-system/components/typography';
import { SxProp, View, Image } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface ReplaceCardProps {
  onClose: () => void;
}

export const ReplaceCardWebThreeScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose } = props;
  const { t } = useTranslation('account-management');
  const { topHeader, body, textMb, itemStyle, address, textColor, itemAlign } = sxStyles;
  const [selected, setSelected] = useState<boolean>(false);

  return (
    <View>
      <View sx={topHeader}>
        <Icon name="successSpecial" height={108} width={108} />
        <View sx={textMb}>
          <TextTitle bold>Replace Card Instruction Placed</TextTitle>
          <TextBody>Your new UTGL Card will be sent to your mailing address in 4-5 business days when ready.</TextBody>
        </View>
      </View>
      <View sx={body}>
        <View sx={{ gap: 12 }}>
          <TextBody sx={itemStyle}>
            <TextBody secondary>Reason to replace card</TextBody>
            <TextBody>It’s lost/stolen</TextBody>
          </TextBody>
          <TextBody sx={itemAlign}>
            <TextBody secondary>Delivery Method</TextBody>
            <TextBody sx={address}>
              Mail to address: <br /> Block 1, 1/F, Flat A, Super
              <br /> Building, 1 Sample Road, <br />
              Jordan, Hong Kong
            </TextBody>
          </TextBody>
          <TextBody sx={itemStyle}>
            <TextBody secondary>Replacement Fee</TextBody>
            <TextBody sx={textColor}>- 50.00 HKD</TextBody>
          </TextBody>
          <TextBody sx={itemStyle}>
            <TextBody secondary>Instruction Time</TextBody>
            <TextBody>2022-09-01 16:44:00</TextBody>
          </TextBody>
          <TextBody sx={itemStyle}>
            <TextBody secondary>Ref ID</TextBody>
            <TextBody>A123456789</TextBody>
          </TextBody>
        </View>
        <View sx={{ flex: 1, display: 'grid', gap: '$3', mt: '$10' }}>
          <UniButton sx={{ width: '100%' }} label="Reture" onPress={onClose} />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 30,
    paddingBottom: 12
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  textMb: {
    textAlign: 'center',
    gap: 8
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 20
  },
  itemAlign: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  title: {
    color: '$textSecondary',
    fontSize: 12
  },
  address: {
    textAlign: 'right',
    lineHeight: 20
  },
  textColor: {
    color: '#F5423E'
  }
};
